import {useChangeFunctions} from '@domain/shifthandover'
import {CommonDropDown, CommonProps} from '@hconnect/common/components'
import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE} from '../../consts'

export const FunctionTitle: React.FC<{functionId?: string}> = ({functionId}) => {
  const {
    t,
    i18n: {language}
  } = useTranslation(SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE)
  const {data: functions} = useChangeFunctions({language})

  const selectedFunction = functions?.find(({id}) => id === functionId)

  if (functionId && functions && selectedFunction) {
    return (
      <>
        {t(`shiftEvent.function.${selectedFunction.code}`, {defaultValue: selectedFunction.name})}
      </>
    )
  }

  return <>{functionId || ''}</>
}

export const ParameterChangeFunctionDropdown: React.FC<CommonProps<string>> = ({
  disabled,
  value,
  ...props
}) => {
  const {
    i18n: {language}
  } = useTranslation(SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE)
  const {data: changeFunctions} = useChangeFunctions({language})

  const option = useMemo(() => {
    if (!changeFunctions) {
      return value ? [value] : []
    }
    const functionIds = changeFunctions.map(({id}) => id)
    return value && !functionIds.includes(value) ? [value, ...functionIds] : functionIds
  }, [value, changeFunctions])

  return (
    <CommonDropDown
      {...props}
      value={value}
      disabled={disabled || option.length === 0}
      keyName="function"
      options={option}
      customTemplate={(key) => {
        return <FunctionTitle functionId={key} />
      }}
    />
  )
}
